import { sharedRedeliveryTermHeading } from './sharedRedeliveryTermHeading';

export const fixtureRedeliveryTermHeading = {
    ...sharedRedeliveryTermHeading,
    hide: false,
};
